import Vue from 'vue'
import App from './App.vue'
import VueTippy from 'vue-tippy'
import VueCompositionApi from '@vue/composition-api'
import router from './router'
import { bootstrapHotjar } from './services/hotjar'
import store from './store'
import * as FullStory from '@fullstory/browser'
import PortalVue from 'portal-vue';

FullStory.init({ orgId: '100Q42' })
Vue.prototype.$FullStory = FullStory
import { bootstrapSmartlook } from '@/services/smartlook'

store.subscribe((mutation, state) => {
    localStorage.setItem('store', JSON.stringify(state))
})

bootstrapHotjar()

Vue.config.productionTip = false

Vue.use(PortalVue);
Vue.use(VueCompositionApi)
Vue.use(VueTippy)

bootstrapSmartlook()

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
